<template>
	<div class="table-assigned-processes">
		<div class="" v-if="assignments.length > 0">
			<div class="row">
				<div class="col-sm-6" style="float: right !important;">
					<div id="" class="">
						<label>
							<div class="input-group">
								<input id="searchCandidateAssignment" type="search" v-model="search" class="form-control" placeholder="Buscar por nombre de candidato" aria-controls="">
								<span class="input-group-addon">
									<i class="fa fa-search"></i>
								</span>
							</div>
						</label>
					</div>
				</div>
			</div>
			<div :class="typeMessage" role="alert" id="message-update" v-if="message != ''">
				{{message}}
			</div>
			<table class="table" id="tableAassignedProjects">
				<thead>
					<tr>
						<th style="width: 5% !important;">ID</th>
						<th style="width: 5% !important;">Proceso</th>
						<th style="width: 5% !important;">Cliente</th>
						<th style="width: 15% !important;">Fecha creación</th>
						<th style="width: 15% !important;">Aspirante</th>
						<th style="width: 11% !important;">Estado</th>
						<th style="width: 9% !important;">Tipo de proceso</th>
						<th style="width: 9% !important;">Trabajar</th>
						<th style="width: 9% !important;">Desasignar</th>
						<th style="width: 9% !important;">Agendar</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(assignment, index) in assignments" :key="assignment.id">
						<td>{{assignment.id}}</td>
						<td>{{assignment.project | getAttribute('id')}}</td>
						<td>{{assignment.project.client | getAttribute('name')}}</td>
						<td>{{assignment.created_at}}</td>
						<td>{{assignment.person_full_name}}</td>
						<td>{{assignment | status }}</td>
						<td>{{assignment.assignment_type | getAttribute('name') }}</td>
						<td>
							<a :id="`btnWork${index}`" class="btn btn-primary" :href="`/workers/work/${assignment.id}`" v-if="assignment.assignment_type.id != 4">Trabajar</a>
							<p v-else>Trabajar en la app</p>
						</td>
						<td><button :id="`btnUnassigned${index}`" type="button" class="btn btn-danger" @click.prevent="deallocateItToMe(assignment.id, index)">Desasignar</button></td>
						<td>
							<button :id="`btnScheduleVideoCall${index}`" type="button" class="btn btn-warning schedule-video-call" data-toggle="modal" data-target="#modalEscheduleVideoCall" @click.prevent="assignmentIdSchedule = assignment.id">
								Agendar <i class="fa fa-calendar"></i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<modal-schedule-video-call :assignment_id="assignmentIdSchedule"/>
			<div class="row" v-if="paginateAssignments != null">
				<div class="col-sm-5 hidden-xs">
						<div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Mostrando {{assignments.length}}. Pagina {{paginateAssignments.current_page}} de {{paginateAssignments.total_pages}}</div>
				</div>
				<div class="col-sm-7 col-xs-12 clearfix">
					<div class="dataTables_paginate paging_bootstrap" id="DataTables_Table_0_paginate">
						<ul class="pagination pagination-sm remove-margin">
							<li class="prev" @click.prevent="changePage(paginateAssignments.prev_page)" v-if="paginateAssignments.prev_page > 0">
								<a href="" >
									<i class="fa fa-chevron-left"></i>
									Anterior
								</a>
							</li>
							<li :class="liActive(p)" v-for="p in range(this.paginateAssignments.total_pages)" :key="p" @click.prevent="changePage(p)">
								<a>{{p}}</a>
							</li>
							<li class="next" @click.prevent="changePage(paginateAssignments.next_page)" v-if="paginateAssignments.next_page != null">
								<a href="">
									Siguiente
									<i class="fa fa-chevron-right">
									</i>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div id="progress" class="progress" v-else>
			<div class="progress-bar progress-bar-striped bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios';
import ModalScheduleVideoCall from './../video-call/modal-schedule-video-call.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'TableAssignedProcesses',
	props: ['current_user'],
	computed: {
    ...mapGetters(['assignments', 'paginateAssignments', 'unassignedProjects', 'paginateUnassignedProjects',])
	},
	methods: {
		...mapMutations(['changeAssignments', 'changePaginateAssignments', 'changeUnassignedProjects', 'changePaginateUnassignedProjects']),
		liActive(page){
			var classLi = ""
			if(page == this.paginateAssignments.current_page){
				classLi = "active"
			}
			return classLi
		},
		deallocateItToMe(assignment_id, index){
			this.defaultValuesAxios()
			axios.put('/workers/deallocate_it_to_me/' + assignment_id, {}).then(res=>{
				if(res.status == 200){
					var assignment = res.data.assignment
					if(assignment.id == assignment_id){
						this.assignments.splice(index, 1)
						this.showMessage(`Asignación ${assignment_id} desasignada`, 'alert-success')
					}
					this.getProjects()
				}else{
					this.showMessage('No se pudo desasignar', 'alert-warning')
				}
			}, (err) => {
				this.showMessage('No se pudo desasignar', 'alert-danger')
			})
		},
		getProjects(){
			this.defaultValuesAxios()
			this.changeUnassignedProjects([])
			axios.get('/workers.json?page=' + this.page).then(res=>{
				if(res.status == 200){
					this.changeUnassignedProjects(res.data.unassigned_projects.data)
					this.changePaginateUnassignedProjects(res.data.unassigned_projects.paginate)
					this.hideAssignments()
				}
			})
		},
		changePage(page){
			this.page = page
			this.changePaginateAssignments(null)
			this.displayLinks = page + 5
			this.getAssignments()
		},
		range(end) {
			return new Array(end - this.paginateAssignments.current_page).fill().map((d, i) => i + this.paginateAssignments.current_page);
		},
		defaultValuesAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
		},
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},
		getAssignments(){
			this.defaultValuesAxios()
			this.changeAssignments([])
			axios.get('/workers.json?assign_page=' + this.page).then(res=>{
				if(res.status == 200){
					this.changeAssignments(res.data.assignments.data)
					this.changePaginateAssignments(res.data.assignments.paginate)
				}
			})
		},
		searchAssignments(){
			if(this.search.length > 3){
				this.defaultValuesAxios()
				axios.post('/workers/search_assigned_list.json?search=' + this.search).then(res=>{
					if(res.status == 200){
						this.changeAssignments(res.data.assignments.data)
						this.changePaginateAssignments(res.data.assignments.paginate)
						if(this.assignments.length == 0){
							this.getAssignments()
						}
					}
				})
			}else{
				if(this.search.length == 0){
					this.getAssignments()
				}
			}
		},
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},
	},
	data() {
		return {
			message: '',
			typeMessage: '',
			show: [],
			displayLinks: 5,
			page: 1,
			search: '',
			assignmentIdSchedule: null
		}
	},
	watch: {
		search: function(){
			this.searchAssignments()
		}
	},
	created () {
		this.getAssignments()
	},
	components: {
		'modal-schedule-video-call': ModalScheduleVideoCall
	},
	filters: {
		getAttribute: function(object, key){
			if(object != null){
				return object[key]
			}else{
				return ''
			}
		},
		status: function(object){
			if(object != null){
				if(object.status == 'working'){
					return 'Trabajando'
				}else{
					return object.status
				}
			}else{
				return ''
			}
		}
	}
}
</script>
<style scoped>
</style>
